import { toast } from "react-toastify";
import { ablBaseUrl, baseUrl } from "../../utils/sysEnv";
import * as types from '../types'
import axios from "axios";
import { authToken } from "../../utils/helper";
import { deleteCookie, setCookie } from 'cookies-next';


// GET ALL tariffs
export const getUsers = () => async (dispatch) => {
    try {
      dispatch({ type: types.SET_LOADING });
      await axios
        .get(`${ablBaseUrl}/users`)
        .then((res) => {
          dispatch({
            type: types.GET_USERS,
            payload: res.data.data,
          });
        })
        .catch((error) => {
          if (error.response === undefined) {
            toast.error("axios error", error.message.data.error);
            //   setError(dispatch, error.message)
          } else {
             toast.error("axios error", error.response.data.error);
            //   setError(dispatch, error.response.data.error)
          }
        });
    } catch (err) {
       toast.error("axios error", err.message.data.error);
    }
  };


  
export const userUpdatePassword = data => async (dispatch) => {
  try {
    dispatch({ type: types.SET_LOADING });
    await axios
      .put(`${baseUrl}/users/updateuserpassword`, data, authToken(data.token))
      .then((res) => {
        let token = res.data.token;
        if(res.data.token){ 
          axios
          .get(`${baseUrl}/auth/me`, authToken(token), data)
          .then(tmpUser => {
            let newUser = tmpUser.data.data;
            newUser.token = token;
            dispatch({
              type: types.LOGIN,
              payload: newUser,
            });
            deleteCookie('loggedInUser');
            setCookie('loggedInUser', JSON.stringify(newUser))
            if(newUser){
                window.location = "/dashboard"; 
            }   
          })
          .catch(error => {
            toast.error('error', 'oops there was an error');
            dispatch({ type: types.RESET });
          });
        toast.success('Pasword updated successfully');
        }
      })
      .catch((error) => {
        if (error.response === undefined) {
          toast.error(error.response.data.error);
          dispatch({ type: types.RESET_LOADING });
        } else {
           toast.error(error.response.data.error);
           dispatch({ type: types.RESET_LOADING });
        }
      });
  } catch (err) {
    dispatch({ type: types.SET_ERROR });
     toast.error(err.message.data.error);
     dispatch({ type: types.RESET_LOADING });
  }
};


export const submitContactForm = data => async (dispatch) => {
    
  try {
    dispatch({ type: types.SET_LOADING });
    await axios
      .post(`${baseUrl}/users/contact`, data, authToken(data.token))
      .then((res) => {
        dispatch({
          type: types.CONTACT_FORM,
          payload: res.data.data,
        });
        toast.success('Contact informaiton submitted successfully');
        // window.location = "/dashboard";
      })
      .catch((error) => {
        if (error.response === undefined) {
          toast.error(error.response.data.error);
          dispatch({ type: types.RESET_LOADING });
        } else {
           toast.error(error.response.data.error);
           dispatch({ type: types.RESET_LOADING });
        }
      });
  } catch (err) {
    dispatch({ type: types.SET_ERROR });
     toast.error(err.message.data.error);
     dispatch({ type: types.RESET_LOADING });
  }
};